module.exports = __webpack_public_path__ + "img/graduate-2013-course-class.08a5fbfa.jpg";